const buildNewUrl = (location, filterParams, genericFilterParam) => {
    const urlSearchParams = new URLSearchParams(location.search);

    if (genericFilterParam) {
        // line role group case: only takes in a 'filter' param
        urlSearchParams.set("filter", JSON.stringify(filterParams));

        if (urlSearchParams.get("filter")) {
            return `${location.pathname}?${urlSearchParams.toString()}`;
        }
    } else {
        // site group case: takes in individual filter params for lineIds, lineName, siteGroupName
        Object.keys(filterParams).forEach((key) => {
            if (filterParams[key] !== undefined && filterParams[key] !== "") {
                urlSearchParams.set(key, filterParams[key]);
            } else {
                urlSearchParams.delete(key);
            }
        });

        const queryString = urlSearchParams.toString();
        if (queryString) {
            return `${location.pathname}?${queryString}`;
        }
    }

    return "";
};

export default buildNewUrl;
